import { Component, computed, inject } from '@angular/core';
import { MainCardComponent } from '../../common-components/main-card/main-card.component';
import { HeaderComponent } from '../../common-components/header/header.component';
import { Router } from '@angular/router';
import { NgForOf, NgIf, SlicePipe } from '@angular/common';
import { AssignmentService } from '../../services/assignment.service';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    MainCardComponent,
    HeaderComponent,
    NgIf,
    NgForOf,
    SlicePipe,
    TranslocoDirective
  ],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss'
})
export class MainPageComponent {
  protected auditInProgress = computed(() => this.assignmentServices.auditInProgress());
  protected upcomingAudits = computed(() => this.assignmentServices.upcomingAudits());
  protected finishedAudits = computed(() => this.assignmentServices.finishedAudits());
  private audits = computed(() => this.assignmentServices.assignments());

  private router = inject(Router);
  private assignmentServices = inject(AssignmentService);

  protected navigateToAll() {
    this.navigate('assignments')
  }

  protected startAdHocAudit() {
    this.navigate('audit-setup')
  }

  protected delete(event: string) {
    let index = this.audits().findIndex(x => x.id === event);
    if (index !== -1) {
      this.audits().splice(index, 1);
    }
  }

  private navigate(route: string): void {
    this.router.navigate([route]).then();
  }
}
